module.exports = __webpack_public_path__ + "img/yann-allegre-1408153-unsplash.dbdabeae.jpg";